import React from 'react';
import { Box, Button, Typography, alpha } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ACCENT, TEXT_PRIMARY, TEXT_SECONDARY } from './SaaSTokens';

/**
 * Floating bar shown when table rows are selected.
 */
const BulkActionBar = ({
  count = 0,
  label = 'selected',
  onClear,
  children,
  sx = {},
}) => {
  if (!count) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: { xs: 'stretch', sm: 'center' },
        justifyContent: 'space-between',
        flexDirection: { xs: 'column', sm: 'row' },
        flexWrap: 'wrap',
        gap: 1.5,
        mb: 2,
        px: { xs: 1.5, sm: 2 },
        py: 1.25,
        borderRadius: '12px',
        background: `linear-gradient(135deg, ${alpha(ACCENT, 0.14)} 0%, ${alpha('#0b1220', 0.95)} 100%)`,
        border: `1px solid ${alpha(ACCENT, 0.35)}`,
        boxShadow: `0 4px 20px ${alpha(ACCENT, 0.12)}`,
        ...sx,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography
          sx={{
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: '0.72rem',
            fontWeight: 600,
            letterSpacing: 1.2,
            textTransform: 'uppercase',
            color: alpha(TEXT_PRIMARY, 0.9),
          }}
        >
          {count} {label}
        </Typography>
        {onClear && (
          <Button
            size="small"
            startIcon={<CloseIcon sx={{ fontSize: 16 }} />}
            onClick={onClear}
            sx={{
              minWidth: 0,
              color: alpha(TEXT_SECONDARY, 0.85),
              fontSize: '0.75rem',
              textTransform: 'none',
              '&:hover': { color: TEXT_PRIMARY, background: alpha('#fff', 0.06) },
            }}
          >
            Clear
          </Button>
        )}
      </Box>
      {children && (
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          flexWrap: 'wrap',
          width: { xs: '100%', sm: 'auto' },
          '& .MuiButton-root': { flex: { xs: '1 1 auto', sm: '0 0 auto' } },
        }}>
          {children}
        </Box>
      )}
    </Box>
  );
};

export default BulkActionBar;
